export const EVENTS = Object.freeze({
  AccountsListViewed: 'Accounts List Viewed',
  AccountsViewed: 'Accounts Viewed',
  ArticleViewed: 'Article Viewed',
  // this generic event can be used for all banners going forward
  BannerClicked: 'Banner Clicked',
  CheckoutStarted: 'Checkout started',
  CheckoutCompleted: 'Checkout completed',
  ClaimsListViewed: 'Claims List Viewed',
  ClaimDetailsViewed: 'Claim Details Viewed',
  DiscoverSearchResultsViewed: 'Discover Search Results Viewed',
  DiscoverSearchResultsClicked: 'Discover Search Results Clicked',
  ErrorViewed: 'ErrorViewed',
  ExpiringFundsBannerClicked: 'Expiring Funds Banner Clicked',
  ExpiringFundsExperimentBannerClicked:
    'Expiring Funds Experiment Banner Clicked',
  ExternalStoreLink: 'External Store Viewed',
  EventViewed: 'Event viewed',
  EventRegistered: 'Event Registered',

  EligibilityDrawerOpened: 'Eligibility Drawer Opened',
  EligibilitySearch: 'Eligibility Search',

  HelpCenterViewed: 'Help Center Viewed',
  HomepageSortEnabled: 'Homepage Sort Enabled',
  ImageCarouselUsed: 'Image Carousel Used',
  MerchantViewed: 'Merchant viewed',
  MerchantProductViewed: 'Merchant product viewed',
  MerchantWebsiteViewed: 'Merchant website viewed',
  NewClaimSubmitted: 'New Claim Submitted',
  NewClaimViewed: 'New Claim Viewed',
  NewExpenseSubmitted: 'New Expense Submitted',
  NewExpenseViewed: 'New Expense Viewed',
  NoCostToggleEnabled: 'No Out of Pocket Cost Toggle Enabled',
  NotFoundViewed: '404 Viewed',

  OnboardingViewed: 'Onboarding Viewed',
  OnboardingInterstitialTaskPressed: 'Onboarding Interstitial Task Pressed',
  OnboardingInterstitialTasksViewed: 'Onboarding Interstitial Tasks Viewed',
  OnboardingInterstitialTasksDismissed:
    'Onboarding Interstitial Tasks Dismissed',
  PaymentsViewed: 'Payments Viewed',
  ProgramPolicyViewed: 'Program Policy Viewed',
  QuerySearched: 'Query Searched',
  RecognitionViewed: 'Recognition Viewed',
  RecognitionSent: 'Recognition Sent',
  RelatedSearchResultsClicked: 'Related Search Results Clicked',
  RelatedSearchResultsViewed: 'Related Search Results Viewed',
  RemoveCard: 'Remove Card',
  ReservationCancelled: 'Cancel reservation',
  SearchResultsViewed: 'Search Results Viewed',
  SearchResultsClicked: 'Search Results Clicked',
  StoreViewed: 'Store Viewed',

  StoreLandingDropdownClicked: 'Dropdown Clicked',

  ToggleUsed: 'Toggle Used',
  TopProductsBannerClicked: 'Top Products Banner Clicked',
  TwicCardAdPressed: 'Twic Card Ad Pressed',
  TwicCardViewed: 'Twic Card Viewed',

  UsedPoints: 'Used Points',
  DropdownClicked: 'Dropdown Clicked',

  MisoProductRecommendationsViewed: 'Miso product recommendations viewed',
  MisoProductRecommendationClicked: 'Miso product recommendation clicked',
  ViewAllClicked: 'View All Clicked',
});

export enum MisoRecommendationType {
  ProductToProduct = 'product_to_product',
}
